<template>
  <article>
    <div class="filter mt-20">
      <div class="filter__item">
        <el-select class="filter__input" size="mini" v-model="filters.adid" filterable placeholder="请选择">
          <el-option :label="item.title" :value="item.adid" v-for="(item, index) in adLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">标题：</div>
        <el-input v-model="filters.title" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">跟单人：</div>
        <el-select class="filter__input" size="mini" v-model="filters.opid">
          <el-option :label="item.nickname" :value="item.opid" v-for="(item, index) in operLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">下家：</div>
        <el-select class="filter__input" size="mini" v-model="filters.acid" filterable>
          <el-option :label="item.name" :value="item.acid" v-for="(item, index) in adChnLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">口令墙：</div>
        <el-select class="filter__input" size="mini" v-model="filters.awid" filterable>
          <el-option :label="item.title" :value="item.awid" v-for="(item, index) in watchwordLists" :key="index"></el-option>
        </el-select>
      </div>
      <div class="filter__item">
        <div class="filter__name">状态：</div>
        <el-select class="filter__input" size="mini" v-model="filters.status">
          <el-option :label="item.name" :value="item.value" v-for="(item, index) in statusList" :key="index"></el-option>
        </el-select>
      </div>
    </div>
    <div class="filter mt-10 mb-20">
      <div class="filter__item">
        <div class="filter__name">订单ID：</div>
        <el-input v-model="filters.oid" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <div class="filter__item">
        <div class="filter__name">快递单号：</div>
        <el-input v-model="filters.express_id" placeholder="" size="mini" class="filter__input"></el-input>
      </div>
      <button class="blue-small-btn mr-10" @click="getList">搜索</button>
      <el-popconfirm
        confirm-button-text='确定'
        cancel-button-text='不用了'
        icon="el-icon-info"
        icon-color="red"
        title="是否按照当前筛选条件，批量查询快递单号？"
        @confirm="queryExpressTrack"
      >
      <button class="blue-small-btn mr-10"  slot="reference" >查询</button>
      </el-popconfirm>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700" :summary-method="getSummaries" awid-summary>
      <el-table-column prop="oeid" label="ID" width="50" align="center">
      </el-table-column>
      <el-table-column prop="oids" label="订单号" width="" align="center">
        <template slot-scope="scope">
          <div class="flex jcc">
            <router-link class="underline fc-blue pointer" target="_blank" :to="{path: '/adOrder', query: {oids: scope.row.oid}}">{{scope.row.oid}}</router-link>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="oper_nickname" label="跟单人" width="70" align="center">
      </el-table-column>
      <el-table-column prop="adid" label="广告" width="" align="center">
        <template slot-scope="scope">
          <div @dblclick="setFiltersValue('adid', scope.row.adid)">{{scope.row.ad_title}}({{scope.row.adid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="acid" label="下家" width="" align="center">
        <template slot-scope="scope">
          <div>{{scope.row.chn_name}}({{scope.row.acid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="awid" label="口令" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.awid !== 0" @dblclick="setFiltersValue('awid', scope.row.awid)">{{scope.row.watchword_title}}({{scope.row.awid}})</div>
        </template>
      </el-table-column>
      <el-table-column prop="company" label="快递公司" width="" align="center">
      </el-table-column>
      <el-table-column prop="company_code" label="公司编号" width="" align="center">
      </el-table-column>
      <el-table-column prop="express_id" label="快递单号" width="" align="center">
      </el-table-column>
      <!--
      <el-table-column prop="phone" label="手机后四位" width="" align="center">
      </el-table-column>
      -->
      <el-table-column prop="scanType" label="扫描类型" width="" align="center">
      </el-table-column>
      <el-table-column prop="scanDate" label="扫描日期" width="" align="center">
      </el-table-column>
      <el-table-column prop="scanSiteName" label="扫描网点" width="" align="center">
      </el-table-column>
      <el-table-column prop="operateUser" label="快递员" width="" align="center">
      </el-table-column>
      <el-table-column prop="operateUserPhone" label="快递员手机号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="tracks" label="快递轨迹" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.tracks !== ''">
            <el-tooltip placement="top" effect="light">
              <div slot="content">
                <div v-html="scope.row.tracks"></div>
              </div>
              <el-button size="mini">显示</el-button>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="signMan" label="收件人" width="" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="100" align="center">
        <template slot-scope="scope">
          <div class="flex jcc aic">
            <div v-if="scope.row.status == 1">查询中</div>
            <div v-if="scope.row.status == 2">失效</div>
            <div v-if="scope.row.status == 3">异常</div>
            <div v-if="scope.row.status == 4">完成</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="100" align="center">
        <template slot-scope="scope">
          <div v-html="formatTimeStamp(scope.row.create_time)"></div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <button class="blue-small-btn mr-10" @click="queryExpressTrack(scope.row.oeid)">查询</button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, pager, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="filters.l" :page-sizes="[20, 50, 80, 100, 200]" :total="filters.total" :current-page="filters.p" class="tac mt-36 pb-36">
    </el-pagination>
  </article>
</template>

<script>
import Clipboard from 'clipboard'
import {adOrderExpressLists, adOrderExpressEdit, adConciseLists, operLists, adChnLists, adWatchwordLists, queryExpressTrack} from '../../../api/api'
import util from '../../../script/util'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'adOrderExpressList',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      opid: '',
      filters: {
        p: 1,
        l: 20,
        total: 0,
        adid: '',
        awid: '',
        acid: '',
        oid: '',
        opid: '',
        status: '',
        oeids: '',
        title: '',
        express_id: ''
      },
      adLists: [],
      operLists: [],
      adChnLists: [],
      watchwordLists: [],
      priorityLists: [],
      lists: [],
      listLoading: false,
      statusList: [
        {
          name: '所有',
          value: ''
        },
        {
          name: '查询中',
          value: 1
        },
        {
          name: '失效',
          value: 2
        },
        {
          name: '异常',
          value: 3
        },
        {
          name: '完成',
          value: 4
        }
      ]
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    // 格式化时间
    formatTimeStamp (time) {
      return util.formatTimeStamp(time)
    },
    setFiltersValue (key, value) {
      if (this.filters[key] === '') {
        this.filters[key] = value
      } else {
        this.filters[key] = ''
      }
      this.getList()
    },
    getSummaries (param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (['total', 'order_amount', 'remain', 'price', 'income', 'all_income', 'chn_amount', 'unpaid'].includes(column.property)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toFixed(2)
        } else {
          sums[index] = 'N/A'
        }
      })

      return sums
    },
    copyLink () {
      let clipboard = new Clipboard('.copy-btn')
      clipboard.on('success', e => {
        this.$notify({
          title: '成功',
          message: '复制成功',
          type: 'success'
        })

        // 释放内存
        clipboard.destroy()
      })

      clipboard.on('error', e => {
        this.$notify({
          title: '失败',
          message: '复制失败',
          type: 'error'
        })

        // 释放内存
        clipboard.destroy()
      })
    },
    getPriorityLists () {
      for (let index = 5; index >= 0; index--) {
        this.priorityLists.push({'label': index, 'value': index})
      }
    },
    adOrderExpressEdit (index, key) {
      let awid = this.lists[index].awid
      let priority = this.lists[index].priority

      let params = {
        awid: awid
      }

      if (key === 'status') {
        params['status'] = this.lists[index].status === 1 ? 0 : 1
      }

      if (key === 'oid') {
        params['oid'] = this.lists[index].oid === 1 ? 0 : 1
      }

      if (key === 'awid') {
        params['awid'] = this.lists[index].awid === 1 ? 0 : 1
      }

      if (key === 'priority') {
        params['priority'] = priority
      }

      adOrderExpressEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.getList()
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getAdLists () {
      let params = {
        market: 3,
        l: 500,
        p: 1
      }
      adConciseLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.adLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.adid + ')',
              adid: item.adid
            }
          })
          this.adLists.unshift({
            title: '所有',
            adid: ''
          })
        }
      })
    },
    getOperLists () {
      let params = {
        market: 3,
        status: 1,
        l: 500,
        p: 1
      }
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.operLists = data.d.lists.map((item, index) => {
            return {
              nickname: item.nickname,
              opid: item.opid
            }
          })
          this.orderOperLists = this.operLists.slice()
          this.operLists.unshift({
            nickname: '所有',
            opid: ''
          })
        }
      })
    },
    getAdChnLists () {
      let params = {
        l: 500,
        p: 1,
        opid: this.opid
      }

      if ([2, 4, 16].includes(this.opid)) {
        delete params.opid
      }

      adChnLists(params).then((res) => {
        let data = res.data || {c: -1}

        if (!data.c) {
          this.adChnLists = data.d.lists.map((item, index) => {
            return {
              name: item.name,
              acid: item.acid
            }
          })
          this.adChnLists.unshift({
            name: '所有',
            acid: ''
          })
        }
      })
    },
    getAdWatchwordLists () {
      let params = {
        l: 500,
        p: 1
      }
      adWatchwordLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.watchwordLists = data.d.lists.map((item, index) => {
            return {
              title: item.title + '(' + item.awid + ')',
              awid: item.awid
            }
          })
          this.watchwordLists.unshift({
            title: '所有',
            awid: ''
          })
        }
      })
    },
    queryExpressTrack (oeids = '') {
      let filters = this.filters
      let params = {}

      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.acid !== '') {
        params.acid = filters.acid
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.oid !== '') {
        params.oid = filters.oid
      }
      if (oeids !== '') {
        params.oeids = oeids
      }
      if (filters.express_id !== '') {
        params.express_id = filters.express_id
      }

      queryExpressTrack(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '',
            message: '正在查询，请耐心等待',
            type: 'success'
          })
        }
      }).catch(() => {
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    getList () {
      let filters = this.filters
      let params = {
        p: filters.p,
        l: filters.l
      }

      if (filters.adid !== '') {
        params.adid = filters.adid
      }
      if (filters.title !== '') {
        params.title = filters.title
      }
      if (filters.opid !== '') {
        params.opid = filters.opid
      }
      if (filters.acid !== '') {
        params.acid = filters.acid
      }
      if (filters.awid !== '') {
        params.awid = filters.awid
      }
      if (filters.oid !== '') {
        params.oid = filters.oid
      }
      if (filters.status !== '') {
        params.status = filters.status
      }
      if (filters.express_id !== '') {
        params.express_id = filters.express_id
      }

      this.listLoading = true
      adOrderExpressLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.opid = parseInt(window.localStorage.getItem('opid'))
    this.getPriorityLists()
    this.getAdLists()
    this.getOperLists()
    this.getAdChnLists()
    this.getList()
    this.getAdWatchwordLists()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
    'filters.adid': 'getList',
    'filters.acid': 'getList',
    'filters.awid': 'getList',
    'filters.oid': 'getList',
    'filters.opid': 'getList',
    'filters.title': 'getList',
    'filters.express_id': 'getList',
    'filters.status': 'getList'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/ad/adOrderExpress.vue